let language = {
    PRODUCT_DESIGN_EDITER_MV_NAV_LOADING_ISSUE_TITLE: "Custom Steps Failed to Load",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT: "We encountered an issue loading customization step. Would you like to go back to the previous step?",
    RANDOM_DESIGN_EDITER_PROCEED_TO_DESIGN:"PROCEED TO {{designName}}",

}
export { language }